import { type ReactNode } from "react";

type PageTitleProps = {
  children: ReactNode;
  className?: string;
};

const PageTitle = ({ children, className = "" }: PageTitleProps) => (
  <h1 className={`text-xl sm:text-2xl font-semibold uppercase ${className}`.trim()}>
    {children}
  </h1>
);

export default PageTitle;
